import { render, staticRenderFns } from "./BulkUpload.vue?vue&type=template&id=4f2ccc32&scoped=true&"
import script from "./BulkUpload.vue?vue&type=script&lang=js&"
export * from "./BulkUpload.vue?vue&type=script&lang=js&"
import style0 from "./BulkUpload.vue?vue&type=style&index=0&id=4f2ccc32&scoped=true&lang=css&"
import style1 from "./BulkUpload.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ccc32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f2ccc32')) {
      api.createRecord('4f2ccc32', component.options)
    } else {
      api.reload('4f2ccc32', component.options)
    }
    module.hot.accept("./BulkUpload.vue?vue&type=template&id=4f2ccc32&scoped=true&", function () {
      api.rerender('4f2ccc32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Admin/Customers/BulkUpload.vue"
export default component.exports